import { Navigate } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";

import useAuth from "../../hooks/useAuth";

export default function ProtectedRoute({

    children

}) {

    const {

        user,

        loading

    } = useAuth();

    if (loading) {

        return (

            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100vh"
            >

                <CircularProgress />

            </Box>

        );

    }

    if (!user) {

        return (

            <Navigate
                to="/login"
                replace
            />

        );

    }

    return children;

}